import React from 'react';
export const PentagonFill = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`btfont ${props.className ? props.className : ''}`}><path d="m8 0 8 6.5-3 9.5H3L0 6.5 8 0z" fillRule="evenodd" /></svg>
);
